/* eslint-disable
    func-names,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model', '_'];
const factory = function (Model, _) {
  let FeatureMeta;
  return (FeatureMeta = (function () {
    FeatureMeta = class FeatureMeta extends Model {
      static initClass() {
        this.prototype.$url = 'clientsettings.json/features';
      }
    };
    FeatureMeta.initClass();
    return FeatureMeta;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.featuremeta', moduleDeps)
  .factory('FeatureMeta', factory);
